import { PanelParams } from "./IPanelFactory";
import { Panel } from "./panel";

export class PanelPyramid extends Panel
{


	public constructor(params: PanelParams)
	{
		super(params);

		this.backendSettings = params.backendSettings;
		this.resid = params.resid.Add("Panel-Pyramid");
		this.resourcesBasePath = params.resourcesBasePath;
        this.audio = params.audio;
		this.translator = params.translator;

		this.systemContext = params.systemContext.CreateSubContext("Panel");

		this.idleAnim = this.systemContext.TimingContext().CreateInterval("idleAnim", 500, () => this.IdleAnim())
		
    }
    
 

	public override SetMessage(message: string): void {
        //this.view.querySelector(".message").innerHTML = message;
        this.messageElem.textContent = message;
	}


	// public ConstructHtml()
    // {

    //     let cssLinear: Partial<CSSStyleDeclaration> = {
    //         borderWidth: Scale.XYpx(5),
    //         borderStyle: "solid",
    //         position: "relative",
    //         margin: "0px auto",
    //         bottom: Scale.Ypx(5),
    //         filter: `blur(${Scale.XYpx(2)})`,
    //         width: "80%",
    //         borderImage: this.ButtonBackground().linearColor
    //     };

    //     let cssVerticalGroup: Partial<CSSStyleDeclaration> = {
    //         display: "flex",
    //         flexDirection: "column",
    //         //justifyContent: "flex-end",
    //     };

    //     let cssHorizontalGroup: Partial<CSSStyleDeclaration> = {
    //         display: "flex",
    //         flexDirection: "row",
    //         flexGrow: "1",
    //     };

    //     let cssLeftRightButton: Partial<CSSStyleDeclaration> = {
    //         flexGrow: "1",
    //         height: Scale.Hpx(100),
    //         width: Scale.Wpx(70),
	// 	};
		
	// 	let cssMenuInfoButton: Partial<CSSStyleDeclaration> = {
    //         flexGrow: "1",
    //         height: Scale.Hpx(40),
    //         width: Scale.Wpx(70),
    //     };

    //     let cssButton: Partial<CSSStyleDeclaration> = {
    //         borderRadius: Scale.XYpx(16),
    
    //         border: `${Scale.XYpx(7)} solid gold`,
    //         //backgroundClip: "padding-box",
    //         borderStyle: "inset",
        
    //         margin: `${Scale.Wpx(5)} ${Scale.Hpx(10)}`,
    //         height: Scale.Hpx(100),
        
    //         display: "flex",
    //         flexDirection: "column",
    //         justifyContent: "space-evenly",
        
    //         //backgroundOrigin: "border-box",
    //         //backgroundClip: "content-box, border-box",
    //         background: "rgba(0, 0, 0,0.5)",
    //     };

    //     let cssLabel: Partial<CSSStyleDeclaration> = {
    //         fontSize: Scale.fhpx(20),
    //         lineHeight: "0px",
    //         //color: "white",
    //         textAlign: "center",
        
    //         fontFamily: "NotoSansDisplay-Bold",
    //         fontWeight: "bold", 
            
    //         color: "white",
    //         textShadow: Array(Math.round(Scale.XY(18))).fill("#001 0px 0px 4px").join(", ") //.repeat() #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px",
    //     };
    
    //     let cssMessageValue: Partial<CSSStyleDeclaration> = {
    //         display: "flex",
    //         justifyContent: "center",
    //         alignItems: "center",
    //         fontSize: Scale.fhpx(20),
        
    //         color: "white",
    //         textShadow: "0 0 10px black",
    //         background: "transparent",
    //     };

    //     let cssCredit: Partial<CSSStyleDeclaration> = {
    //         fontSize: Scale.fhpx(40),
    //         lineHeight: Scale.Hpx(40),
    //         textAlign: "center",
    //         height: "100%",
        
    //         display: "flex",
    //         justifyContent: "center",
    //         alignItems: "center",
        
    //         color: "white",
        
    //         textShadow: `0 0 ${Scale.XYpx(10)} black`,
    //     };

    //     let cssCurrency: Partial<CSSStyleDeclaration> = {
    //         fontSize: Scale.fhpx(15),
    //         textAlign: "center",
    //         color: "yellow",
    //         textShadow: `0 0 ${Scale.XYpx(10)} black`,
    //         position: "relative",
    //         top: Scale.Ypx(14),
    //     }

    //     /* #region Left column */
    //     let leftCol = CreateElement("div", {
    //         classes: ["but-vertical-group", "but-group-value-collect"],
    //         parentToAppend: this.view,
    //         style: {
    //             ...cssVerticalGroup
    //         }
    //     });

    //         this.butVolume = CreateElement("div", {
    //             classes: ["but-vol", "button"],
    //             parentToAppend: leftCol,
    //             style: {
    //                 ...cssLeftRightButton,
	// 				...cssButton,
	// 				borderRadius: Scale.XYpx(50),
    
    //             }
    //         });

    //             let butVolLabel = CreateElement("div", {
    //                 classes: ["but-vol-value", "label"],
    //                 parentToAppend: this.butVolume,
    //                 style: {
    //                     ...cssLabel
    //                 }
    //             });
        
    //         this.butDenom = CreateElement("div", {
    //             classes: ["but-denom", "button"],
    //             parentToAppend: leftCol,
    //             style: {
    //                 ...cssLeftRightButton,
    //                 ...cssButton
    //             }
    //         });

    //             this.denomElem = CreateElement("div", {
    //                 classes: ["denom-value", "message-value"],
    //                 parentToAppend: this.butDenom,
    //                 style: {
    //                     ...cssMessageValue
    //                 }
    //             });

    //                 let butDenomDenom = CreateElement("div", {
    //                     classes: ["denom-denom"],
    //                     parentToAppend: this.denomElem
    //                 });

    //     /* #endregion */

    //     //this.view.innerHTML += 
    //     // `
    //     // <!-- new panel -->
    //     // <div class="but-vertical-group but-group-value-collect">
    //     //     <div class="but-vol button">
    //     //         <span class="but-vol-value label">
    //     //         </span>
    //     //     </div>
        
    //     //     <!--
    //     //     <div class="but-collect button">
    //     //         <span class="but-collect-value label">COLLECT</span>
    //     //     </div>
    //     //     -->
    //     //     <div class="but-denom button">
    //     //         <div class="denom-value message-value"><span class="denom-denom"></span></div>
    //     //     </div>
    //     // </div>`
        
        
    //     // `<div class="but-horizontal-group but-left-group">
    //     //     <div class="but-vertical-group but-group-denom-balance">
        
        
    //     //         <div class="but-credit button">
    //     //             <div class="but-credit-label label">
        
    //     //             </div>
    //     //             <div class="but-credit-currency currency">
    //     //                 <span class="but-credit-currency-value">123,456.00</span>
    //     //                 <!--<span class="but-credit-currncy-icon"></span>-->
    //     //             </div>
    //     //             <div class="but-credit-credit credit">123456</div>
        
    //     //             <div class="linear"> </div>
    //     //         </div>
    //     //     </div>
        
    //     //     <div class="but-vertical-group but-group-lines-totalbet">
    //     //         <div class="but-lines button " style="border: hidden; box-shadow: none;">
    //     //             <div class="but-lines-value message-value"><span class="playinon"> </span>&nbsp;<span
    //     //                     class="selected-lines"></span>&nbsp;
    //     //                 <span class="lines"></span></div>
    //     //         </div>
        
    //     //         <div class="but-horizontal-group">
        
    //     //             <div class="but-totalbet button">
        
    //     //                 <div class="but-totalbet-label label"></div>
    //     //                 <div class="but-totalbet-currency currency">
    //     //                     <span class="but-totalbet-currency-value">123.00</span>
    //     //                     <!--<span class="but-totalbet-currency-symbol"></span>-->
    //     //                 </div>
        
    //     //                 <div class="but-totalbet-credit credit">123</div>
    //     //                 <div class="linear"> </div>
        
    //     //             </div>
        
    //     //             <div class="but-betperline button" style="visibility: hidden;">
    //     //                 <div class="but-betperline-label label"></div>
    //     //                 <div class="but-betperline-credit credit">123</div>
    //     //                 <div class="but-betperline-currency currency">
    //     //                     <span class="but-betperline-currency-value">123.00</span>
    //     //                     <!--<span class="but-betperline-currency-symbol"></span>-->
    //     //                 </div>
    //     //             </div>
    //     //         </div>
    //     //     </div>
        
        
    //     // </div>`;

    //     // LEFT GROUP
    //     let grpLeft = CreateElement("div", {classes: ["but-vertical-group", "but-left-group"], parentToAppend: this.view, style: {
    //         ...cssVerticalGroup,
    //         width: "100%"
    //     }});
    //         let btnLines = CreateElement("div", {classes: ["but-lines", "button"], parentToAppend: grpLeft, style: {
    //             height: Scale.Hpx(35),
    //             //position: "relative",
    //             //left: "-224px",
    //             //background: "transparent",
    //             //...cssButton
    //             display: "flex",
    //             alignItems: "center",
    //             justifyContent: "center",
    //         }});

    //             this.linesMessage = this.translator.Translate(() => this.translator.t.playingOnLines(this.lines));
    //             let btnLinesValue = CreateElement("div", {
    //                 classes: ["but-lines-value", "message-value"], 
    //                 parentToAppend: btnLines, 
    //                 childToAppend: this.linesMessage.location,
    //                 style: {
    //                     ...cssMessageValue
    //                 }
    //             });

    //         let grpDenomBalance = CreateElement("div", {classes: ["but-horizontal-group", "but-group-denom-balance"], parentToAppend: grpLeft, style: {
    //             ...cssHorizontalGroup, 
    //             //flexGrow: "1"
    //             justifyContent: "space-evenly",
    //         }});
    //             let btnBalance = CreateElement("div", {classes:["but-credit", "button"], parentToAppend: grpDenomBalance, style: {
    //                 position: "relative",
    //                 //left: "80px",
    //                 width: Scale.Wpx(220),
    //                 ...cssButton
    //             }});
    //                 let btnBalanceLabel = CreateElement("div", {
    //                     classes: ["but-credit-label", "label"], 
    //                     parentToAppend: btnBalance, 
    //                     childToAppend: this.translator.Anchor(() => this.translator.t.balance),
    //                     style: {
    //                         ...cssLabel
    //                     }
    //                 });

    //                 this.balanceCurrency = CreateElement("div", {classes: ["but-credit-currency", "currency"], parentToAppend: btnBalance, style: {
    //                     ...cssCurrency
    //                 }});
    //                     let btnBalanceCurrencyValue = CreateElement("span", {classes: ["but-credit-currency-value"], parentToAppend: this.balanceCurrency, innerHTML: "123,456.00"});
    //                 this.balanceCredits = CreateElement("div", {classes: ["but-credit-credit", "credit"], parentToAppend: btnBalance, innerHTML: "123456", style: {
    //                     ...cssCredit
    //                 }});
    //                 let btnBalanceLinear = CreateElement("div", {classes: ["linear"], parentToAppend: btnBalance, style: {
    //                     ...cssLinear
    //                 }});

    //         // let grpLinesTotalbet = CreateElement("div", {classes: ["but-vertical-group", "but-group-lines-totalbet"], parentToAppend: grpLeft, style: {
    //         //     ...cssVerticalGroup,
    //         //     justifyContent: "space-evenly"
    //         // }});

    //                     // TODO some spans, not needed 
    //             // let grpTotalPerLine = CreateElement("div", {classes: ["but-horizontal-group"], parentToAppend: grpDenomBalance, style: {
    //             //     ...cssHorizontalGroup
    //             // }});
    //                 let btnTotalbet = CreateElement("div", {classes: ["but-totalbet", "button"], parentToAppend: grpDenomBalance, style: {
    //                     alignSelf: "flex-end",
    //                     //flexGrow: "1",
    //                     position: "relative",
    //                     //left: "127px",
    //                     width: Scale.Wpx(122),
    //                     ...cssButton
    //                 }});
    //                 this.butTotalBet = btnTotalbet;
    //                     let btnTotalbetLabel = CreateElement("div", {
    //                         classes: ["but-totalbet-label", "label"], 
    //                         parentToAppend: btnTotalbet, 
    //                         childToAppend: this.translator.Anchor(() => this.translator.t.tbet),
    //                         style: {
    //                             ...cssLabel
    //                         }
    //                     });
    //                     this.totalBetCurrency = CreateElement("div", {classes: ["but-totalbet-currency", "currency"], parentToAppend: btnTotalbet, innerHTML: "123.00", style: {
    //                         ...cssCurrency
    //                     }});
    //                         // TODO span
    //                     this.totalBetCredits = CreateElement("div", {classes: ["but-totalbet-credit", "credit"], parentToAppend: btnTotalbet, innerHTML: "123", style: {
    //                         ...cssCredit
    //                     }});
    //                     let btnTotalbetLinear = CreateElement("div", {classes: ["linear"], parentToAppend: btnTotalbet, style: {
    //                         ...cssLinear
    //                     }});

    //                 let btnPerLine = CreateElement("div", {
    //                     classes: ["but-betperline", "button"], 
    //                     parentToAppend: grpDenomBalance, 
    //                     style: {
    //                         alignSelf: "flex-end",
    //                         flexGrow: "1",
    //                         ...cssButton,
    //                         display: "none",
    //                     }
    //                 });
    //                     let btnPerLineLabel = CreateElement("div", {
    //                         classes: ["but-betperline-label", "label"], 
    //                         parentToAppend: btnPerLine, 
    //                         childToAppend: this.translator.Anchor(() => this.translator.t.tline),
    //                         style: {
    //                             ...cssLabel
    //                         }
    //                     });
    //                     this.betCredits = CreateElement("div", {
    //                         classes: ["but-betperline-credit", "credit"], 
    //                         parentToAppend: btnPerLine, 
    //                         innerHTML: "123", 
    //                         style: {
    //                             ...cssCredit
    //                         }
    //                     });
    //                     this.betCurrency = CreateElement("div", {
    //                         classes: ["but-betperline-currency", "currency"], 
    //                         parentToAppend: btnPerLine, 
    //                         style: {
    //                             ...cssCurrency
    //                         }
    //                     });
    //                     // TODO span

    //     //this.butTotalBet = this.view.querySelector(".but-totalbet");
         
    //     // this.view.innerHTML += `<div class="but-vertical-group">
        
    //     //     <div class="but-win button">
    //     //         <div class="but-win-label label"></div>
    //     //         <div class="but-win-currency currency">
    //     //             <span class="but-win-currency-value">123,456.00</span>
    //     //             <!--<span class="but-win-currncy-icon">MXN</span>-->
    //     //         </div>
    //     //         <div class="but-win-credit credit">999999</div>
    //     //         <div class="linear"></div>
    //     //     </div>
    //     // </div>`;

        

    //     let centerCol = CreateElement("div", {
    //         classes: ["but-vertical-group"],
    //         parentToAppend: this.view,
    //         style: {
    //             ...cssVerticalGroup
    //         }
    //     });

    //         let butWin = CreateElement("div", {
    //             classes: ["but-win", "button"],
    //             parentToAppend: centerCol,
    //             style: {
    //                 position: "relative",
    //                 ...cssButton,
    //                 width: Scale.Wpx(480),
    //                 flexGrow: "1",
    //             }
    //         });

    //             let butWinLabel = CreateElement("div", {
    //                 classes: ["but-win-label", "label"],
    //                 parentToAppend: butWin,
    //                 style: {
    //                     fontSize: Scale.fhpx(30),
    //                     lineHeight: "0px",
    //                     ...cssLabel
    //                 }
    //             });

    //             this.winCurrency = CreateElement("div", {
    //                 classes: ["but-win-currency", "currency"],
    //                 parentToAppend: butWin,
    //                 style: {
    //                     fontSize: Scale.fhpx(15),
    //                     textAlign: "center",
    //                     color: "yellow",
    //                     textShadow: "0 0 10px black",
    //                     position: "relative",
    //                     top: Scale.Ypx(14),
    //                 }
    //             });

    //                 // let butWinCurrencyValue = CreateElement("span", {
    //                 //     classes: ["but-win-currency-value"],
    //                 //     parentToAppend: butWinCurrency
    //                 // });

    //             this.winCredits = CreateElement("div", {
    //                 classes: ["but-win-credit", "credit"],
    //                 parentToAppend: butWin,
    //                 style: {
    //                     ...cssCredit,
    //                     fontSize: Scale.fhpx(100),
    //                     lineHeight: Scale.Hpx(100),
    //                 }
    //             });

    //             let butWinLinear = CreateElement("div", {
    //                 classes: ["linear"],
    //                 parentToAppend: butWin,
    //                 style: {
    //                     ...cssLinear,
    //                 }
    //             });


        
    //     // this.view.innerHTML += `
    //     // <div class="but-vertical-group but-group-autplay-maxbet-spin-messages but-right-group">
    //     //     <div class="but-message button message-value message" style="border: hidden; box-shadow: none;">
    //     //     </div>
        
    //     //     <div class="but-horizontal-group but-group-autoplay-maxbet-spin">
    //     //         <div class="but-horizontal-group but-group-autoplay-maxbet">
    //     //             <div class="but-auto-play button" style="visibility: hidden;">
    //     //                 <div class="but-auto-play-label label"></div>
    //     //             </div>
        
    //     //             <div class="but-max-bet button" style="position: relative; left: -100px;">
    //     //                 <div class="but-max-bet-label label"></div>
    //     //                 <div class="linear"> </div>
    //     //             </div>
    //     //         </div>
        
        
    //     //         <div class="but-spin button ">
    //     //             <div id="spindix" class="but-spin-label label"></div>
    //     //             <div class="linear"> </div>
    //     //         </div>
    //     //     </div>
    //     // </div>`;

    //     let grpRight = CreateElement("div", {
    //         classes: ["but-vertical-group", "but-group-autplay-maxbet-spin-messages", "but-right-group"],
    //         parentToAppend: this.view,
    //         style: {
    //             ...cssVerticalGroup,
    //             width: "100%",
    //         }
    //     });

    //     this.messageElem = CreateElement("div", {
    //             classes: ["but-message", "button", "message-value", "message"],
    //             parentToAppend: grpRight,
    //             style: {
    //                 height: Scale.Hpx(35),
    //                 position: "relative",
    //                 //left: "-30px",
    //                 //...cssButton,
    //                 display: "flex",
    //                 justifyContent: "center",
    //                 alignItems: "center",
    //                 fontSize: Scale.fhpx(20),
    //                 color: "white",
    //                 textShadow: `0 0 ${Scale.XYpx(10)} black`,
    //                 background: "transparent",
    //             }
    //         });

    //         let grpRightHorizontal = CreateElement("div", {
    //             classes: ["but-horizontal-group", "but-group-autoplay-maxbet-spin"],
    //             parentToAppend: grpRight,
    //             style: {
    //                 ...cssHorizontalGroup,
    //                 flexGrow: "0",
    //                 justifyContent: "space-evenly",
    //             }
    //         });

    //             let grpAutoplayMaxbet = CreateElement("div", {
    //                 classes: ["but-horizontal-group", "but-group-autoplay-maxbet"],
    //                 parentToAppend: grpRightHorizontal,
    //                 style: {
    //                     ...cssHorizontalGroup,
    //                     flexGrow: "0",
    //                 }
    //             });

    //                 this.butAutoplay = CreateElement("div", {
    //                     classes: ["but-auto-play", "button"],
    //                     parentToAppend: grpAutoplayMaxbet,
    //                     style: {
    //                         //flexGrow: "1",
    //                         alignSelf: "flex-end",
    //                         ...cssButton,
    //                         display: "none",
    //                     }
    //                 });

    //                     let butAutplayLabel = CreateElement("div", {
    //                         classes: ["but-auto-play-label", "label"],
    //                         parentToAppend: this.butAutoplay,
    //                         childToAppend: this.translator.Anchor(() => this.translator.t.auto),
    //                         style: {
    //                             ...cssLabel
    //                         }
    //                     });

    //                 this.butMaxBet = CreateElement("div", {
    //                     classes: ["but-max-bet", "button"],
    //                     parentToAppend: grpAutoplayMaxbet,
    //                     style: {
    //                         //flexGrow: "1",
    //                         alignSelf: "flex-end",
    //                         ...cssButton,
    //                         width: Scale.Wpx(120),
    //                     }
    //                 })

    //                     let butMaxBetLabel = CreateElement("div", {
    //                         classes: ["but-max-bet-label", "label"],
    //                         parentToAppend: this.butMaxBet,
    //                         childToAppend: this.translator.Anchor(() => this.translator.t.maxbet),
    //                         style: {
    //                             ...cssLabel,
    //                             lineHeight: Scale.Hpx(30),
    //                         }
    //                     });

    //                     let butMaxBetLinear = CreateElement("div", {
    //                         classes: ["linear"],
    //                         parentToAppend: this.butMaxBet,
    //                         style: {
    //                             ...cssLinear,
    //                         }
    //                     });

    //     let rightCol = CreateElement("div", {
    //         classes: ["but-vertical-group", "but-group-help-games"],
    //         parentToAppend: grpRightHorizontal,
    //         style: {
    //             ...cssVerticalGroup
    //         }
    //     });
    //         this.butHelp = CreateElement("div", {
    //             classes: ["but-help", "button"],
    //             parentToAppend: rightCol,
    //             style: {
	// 				...cssButton,
	// 				...cssMenuInfoButton,
    //             }
    //         });

    //             let butHelpBack = CreateElement("div", {
    //                 classes: ["help-background"],
    //                 parentToAppend: this.butHelp
    //             });

    //                 let butHelpLabel = CreateElement("div", {
    //                     classes: ["but-help-icon", "label"],
    //                     parentToAppend: butHelpBack,
    //                     innerHTML: "INFO",
    //                     style: {
    //                         ...cssLabel
    //                     }
    //                 });

	// 			this.butSpin = CreateElement("div", {
    //                 classes: ["but-spin", "button"],
    //                 parentToAppend: this.view,
    //                 style: {
    //                     width: Scale.Wpx(993),
    //                     alignSelf: "flex-end",
    //                     ...cssButton,
	// 					position: "relative",
	// 					height: Scale.Wpx(254),
	// 					borderRadius: "50%"
    //                 }
    //             });

    //                 // <div class="but-turbo-label">Hold for turbo</div>
    //                 this.turboElem = CreateElement("div", {
    //                     classes: ["but-turbo-label"],
    //                     parentToAppend: this.butSpin,
    //                     innerHTML: "Hold for turbo",
    //                     style: {
    //                         //position: "absolute",
    //                         top: Scale.Ypx(10),
    //                         width: "100%",
    //                         fontSize: Scale.fhpx(12),
    //                         color: "white",
    //                         textAlign: "center",
    //                         textShadow: "#001 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px",
    //                     }
    //                 });

    //                 this.spinElem = CreateElement("div", {
    //                     classes: ["but-spin-label", "label"],
    //                     parentToAppend: this.butSpin,
    //                     style: {
    //                         ...cssLabel,
    //                         fontSize: Scale.fhpx(40),
    //                         lineHeight: Scale.Hpx(60)
    //                     }
    //                 });

    //                 let btnSpinLinear = CreateElement("div", {classes: ["linear"], parentToAppend: this.butSpin, style: {
    //                     ...cssLinear
    //                 }});
    // }

}
